<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="text-h3 mb-2" v-text="'Создать настройку филиала'" />
      </v-col>
    </v-row>
    <v-row>
      <v-form v-model="valid">
        <v-container fluid>
          <v-row>
            <!-- Название -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.code"
                label="Код"
                outlined
                required
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Значение -->
            <v-col cols="12" md="7">
              <v-text-field
                v-model="data.value"
                label="Значение"
                outlined
                required
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- is JSON? -->
            <v-col cols="12" md="7">
              <v-checkbox
                v-model="data.json"
                label="is JSON?"
                required
                :loading="loading"
                :disabled="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col cols="12" md="7">
              <v-btn
                block
                color="primary"
                :loading="loading"
                :disabled="loading"
                @click.prevent="submitSettings"
              >
                Создать
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        data: {
          code: '',
          value: '',
          json: false,
        },
        valid: false,
        loading: false,
      }
    },
    methods: {
      submitSettings () {
        this.loading = true
        this.$store
          .dispatch('branchesSettings/createSettings', this.data)
          .then((res) => {
            this.loading = false
            if (res.status === 200) {
              this.$router.push('/settings/branches')
            }
          })
          .catch((err) => {
            this.loading = false
            console.log(err)
          })
      },
    },
  }
</script>
